import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';


const getBarColor = (value) => {
    if (value <= 20) return '#dc3545'; //danger
    if (value <= 40) return '#ffc107'; //warning
    if (value <= 60) return '#17a2b8'; // info
    if (value <= 75) return '#007bff'; //primary
    return '#00e676';
  };

const BorderLinearProgress = styled(LinearProgress)(({ theme ,value }) => ({
    

  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: getBarColor(value)
  },
}));

export default function CustomizedProgressBars({value=50}) {
 
  return (
    <Stack spacing={2} sx={{ flexGrow: 1 }}>
      <BorderLinearProgress variant="determinate" value={value} />
    </Stack>
  );
}
